module.exports = __webpack_public_path__ + "media/images/countryrect/jo-7b6911129be0dc45abac70741a2ffa4e.svg";